export enum GridID {
  CLIENT = 'portal.client-overview',
  UPLOAD = 'portal.uploaded-files',
  CREDIT = 'portal.payments',
  CREDIT_RECENT = 'portal.credit-recenttransfers',
  CREDIT_DELETED = 'portal.credit-deletedtransfers',
  TEMPLATE = 'portal.from-template',
  LOGS = 'portal.logs-overview',
  LOG_DETAILS = 'portal.log-details',
  USER_MGMT = 'portal.user-mngmt',
  USER_MGMT_ACCOUNT = 'portal.usermngmtaccount-overview',
  PAYMENTS_TRANSACTIONS = 'portal.transactions-payments',
  SIGNATURE_DETAILS = 'portal.signature-details',
  DB_STATUS_HISTORY = 'portal.db-status-history',
  TRANSACTIONS = 'portal.ars-transactions',
  ACCOUNTS = 'portal.ars-accounts',
  VALUE_SERIES = 'portal.ars-valueSeries',
  DLC_DOCUMENTS = 'portal.dlc-overview',
  USERGROUPS = 'portal.usergroups',
  USERGROUPVIEW = 'portal.usergroups-view',
  PENDING_PAYMENT_APPROVALS = 'portal.pending-approvals',
  PENDING_PAYMENT_APPROVAL_DETAILS = 'portal.pending-approval-details',
  PENDING_LIQUIDITY_MGMT_APPROVALS = 'portal.pending-cashpool-approvals',
  PENDING_LIQUIDITY_MGMT_APPROVAL_DETAILS = 'portal.pending-cashpool-approval-details',
  GENERAL_NOTIFICATIONS = 'portal.general-notifications',
  USER_MGMT_USER_GROUPS_VIEW = 'portal.user-mgmt-user-groups-view',
  PAYMENT_TRANSACTION_GROUPS = 'portal.payment-transaction-groups',
  PAYMENT_TRANSACTIONS = 'portal.payment-transactions',
  PAYMENT_STRUCTURED_REMITTANCE_INFOS = 'portal.payment-structured-remittance-infos',
  OWNER = 'portal.owner',
  BANK = 'portal.bank',
  BIC_DIRECTORY_BANK = 'portal.bic-directory-bank',
  TEMPLATE_OVERVIEW = 'portal.template',
  TEMPLATE_VIEW_TRANSACTION_GROUPS = 'portal.template-view-transaction-groups',
  TEMPLATE_VIEW_TRANSACTIONS = 'portal.template-view-transactions',
  PAYMENT_REGULATORY_REPORTING = 'portal.payment-regulatory-reporting',
}
